module.exports = __webpack_public_path__ + "static/media/fourth-card.c63d0bdf.png";